import { useEffect, useState } from "react";
import { Wallet2, TrendingUp, Crown, Check, Lock } from "lucide-react";
import api, { fmtTL } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Profile() {
  const { user } = useAuth();
  const [w, setW] = useState(null);
  useEffect(() => { api.get("/wallet").then(({ data }) => setW(data)); }, []);

  const rankColor = { Bronz: "#cd7f32", Gümüş: "#94a3b8", Altın: "#f59e0b" };

  return (
    <div>
      {/* profile card */}
      <div className="card p-6 text-center">
        <div className="mx-auto h-20 w-20 rounded-full brand-grad grid place-items-center text-white font-head text-3xl font-extrabold">
          {(user?.name || user?.email || "U")[0].toUpperCase()}
        </div>
        <div className="font-head text-xl font-bold mt-3">{user?.name}</div>
        <div className="text-sm text-panel-muted">{user?.email}</div>
        <span className="inline-block mt-3 text-xs font-bold rounded-full px-3 py-1" style={{ background: (rankColor[w?.rank] || "#cd7f32") + "22", color: rankColor[w?.rank] || "#cd7f32" }}>
          {w?.rank || "Bronz"} Üye
        </span>
      </div>

      {/* stats */}
      <div className="grid grid-cols-2 gap-3 mt-4">
        <div className="card p-5"><Wallet2 className="text-brand-500 mb-2" size={22} /><div className="font-head text-2xl font-extrabold">{fmtTL(w?.balance || 0)}</div><div className="text-xs text-panel-muted">Bakiye</div></div>
        <div className="card p-5"><TrendingUp className="text-brand-500 mb-2" size={22} /><div className="font-head text-2xl font-extrabold">{fmtTL(w?.total_deposit || 0)}</div><div className="text-xs text-panel-muted">Toplam Yükleme</div></div>
      </div>

      {/* rank system */}
      <div className="card p-6 mt-4">
        <div className="flex items-center gap-2 mb-1"><Crown className="text-amber-500" size={22} /><h2 className="font-head text-xl font-bold">Rank Sistemi & Avantajların</h2></div>
        <p className="text-sm text-panel-secondary mb-4">Toplam yükleme tutarına göre seviyen otomatik yükselir.</p>
        <div className="space-y-3">
          {(w?.tiers || []).map((t) => {
            const active = (w?.total_deposit || 0) >= t.min;
            const current = w?.rank === t.name;
            return (
              <div key={t.name} className={`rounded-xl border p-4 ${current ? "border-brand-500 bg-brand/5" : "border-panel-border"}`} data-testid={`rank-tier-${t.name}`}>
                <div className="flex items-center justify-between">
                  <span className="font-bold text-sm rounded-full px-3 py-1" style={{ background: (rankColor[t.name] || "#64748b") + "22", color: rankColor[t.name] || "#64748b" }}>{t.name}</span>
                  <span className="text-sm text-panel-muted">{fmtTL(t.min)}+ yükleme</span>
                  {current ? <span className="text-xs font-bold text-brand-500">MEVCUT</span> : active ? <Check size={16} className="text-emerald-500" /> : <span className="text-xs text-panel-muted flex items-center gap-1"><Lock size={12} /> KİLİTLİ</span>}
                </div>
                <div className="mt-2 text-sm text-panel-secondary">
                  {t.discount > 0 ? `%${t.discount} indirim` : "Standart fiyatlar"}{t.bonus > 0 ? ` + ${fmtTL(t.bonus)} bonus` : ""}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
